import { ISolicitationViewModel } from 'viewModels';
import {
  AudienceType,
  CorrespondenceType,
  PaymentSolicitationStatus,
  ServiceStatus,
} from '../../../types/enums';

export const mockSolicitation: ISolicitationViewModel = {
  id: '12345',
  userId: '67890',
  courtId: '112233',
  specialty: {
    id: 'spec-001',
    name: 'Direito Civil',
    disabled: false,
    createdById: 'admin-001',
  },
  correspondence: {
    id: 'corr-001',
    name: 'Correspondência A',
    type: CorrespondenceType.AUDIENCE,
    profileTypes: [],
    attachmentTypes: [],
    disabled: false,
    userId: 'user-001',
  },
  court: {
    id: 'court-001',
    name: 'Tribunal de Justiça',
    districtId: 'district-001',
  },
  client: {
    id: 'client-001',
    name: 'Cliente Exemplo',
  },
  processNumber: '0001234-56.2024.8.09.0001',
  partsNames: [
    { id: 'part-001', name: 'Parte A', solicitationId: '12345' },
    { id: 'part-002', name: 'Parte B', solicitationId: '12345' },
  ],
  folderNumber: 'FOLDER-789',
  audienceType: AudienceType.INITIAL,
  protocolNumber: 'PROTO-56789',
  secrecy: true,
  note: 'Nota sobre a solicitação',
  dateLimit: new Date('2025-03-15T12:00:00Z'),
  attachments: [],
  address: {
    uf: 'SP',
    ufCode: 35,
    city: 'São Paulo',
    cityCode: 3550308,
    street: 'Rua Exemplo',
    complement: 'Apto 101',
    postalCode: '01000-000',
    number: 100,
    latitude: -23.55052,
    longitude: -46.633308,
  },
  value: 1500,
  status: ServiceStatus.IN_APPROVAL_REQUESTER,
  requestsSubmitted: [],
  isOff: false,
  createdAt: new Date('2025-02-26T10:00:00Z'),
  history: [],
  payment: {
    id: 'payment-001',
    paymentSolicitationStatus: PaymentSolicitationStatus.UNPAID,
  },
  finalizationDetails: 'Detalhes finais da solicitação',
  finalizationAttachmentIds: [],
  finalizationAttachments: [],
  isLawyer: false,
  isRepresentative: false,
  isVirtualAudience: true,
  audienceLink: 'https://meet.exemplo.com/audience',
  isIntegratedProtocol: true,
  integratedProtocolValue: 200,
  districtName: 'Distrito Central',
  districtUfCode: 12,
  conversationId: 'conv-001',
  isSolicitationFullDataLoaded: true,
};
